import { useTranslation } from '@flecto/translations'

export type UseAccessibilityPropsOptions = {
  type: 'category' | 'item' | 'logo'
  content: string
}

export function useAccessibilityProps({
  type,
  content,
}: UseAccessibilityPropsOptions) {
  const { t, i18n } = useTranslation('store', {
    keyPrefix: 'store-shared',
  })

  const currentLang = i18n.language || 'pt'

  switch (type) {
    case 'category':
      return {
        'aria-label': t('accessibility.category_for_rent', {
          category_name: content,
        }),
        lang: currentLang,
      }

    case 'item':
      return {
        alt: t('accessibility.item_for_rental', { item_title: content }),
        lang: currentLang,
      }

    case 'logo':
      return {
        alt: t('accessibility.store_logo', { store_name: content }),
        lang: currentLang,
      }
  }
}
